import { render, staticRenderFns } from "./subOrder.vue?vue&type=template&id=788d8278&scoped=true&"
import script from "./subOrder.vue?vue&type=script&lang=js&"
export * from "./subOrder.vue?vue&type=script&lang=js&"
import style0 from "./subOrder.vue?vue&type=style&index=0&id=788d8278&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788d8278",
  null
  
)

export default component.exports